import React, {useEffect} from 'react'
import {useAuthSelector} from './authSlice';
import {useDispatch} from 'react-redux';
import {authActionCreators} from './authActionCreators';
import { firebaseService } from '../../services/firebaseService';
import { Spinner } from '../../components/spinner/Spinner';

export const AuthInitializer: React.FunctionComponent = props => {
    const dispatch = useDispatch();

    const { initializationState, loading }  = useAuthSelector(state => state);
    const isInitialized = initializationState === "initialized";

    useEffect(() => {
        const unsub = firebaseService.auth().onAuthStateChanged(async (user) => {
            console.group('[DIAG] AuthInitializer.onAuthStateChanged');
            console.log('Firebase user:', user ? { uid: user.uid, email: user.email } : null);
            console.groupEnd();
            dispatch(authActionCreators.initializeAuth());
        });
        return () => {
            unsub();
        };
    }, [dispatch]);

    if (initializationState === "error") {
        console.error('[DIAG] AuthInitializer: initializationState is "error" — app will show infinite spinner, children will NOT render');
    }
    if (!isInitialized) {
        console.log('[DIAG] AuthInitializer: not yet initialized, state:', initializationState, '— children blocked');
    }

    return (
        <>
            <Spinner fullPage isLoading={loading} />
            {isInitialized === true && (
                <>
                    {props.children}
                </>
            )}
        </>
    );
}